<script setup>

import { ref, defineProps, defineEmits, watch} from "vue";
import UtilSequence from "../../../../utils/UtilSequence.mjs";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "pedidoDeCompra",
    "email"
]);

const emits = defineEmits([
    "update:email"
]);

//==================================================================//
//============================= Anexos =============================//
//==================================================================//

const anexos = ref(null);

//==================================================================//
//====================== Converte para Base64 ======================//
//==================================================================//

const converteParaBase64 = async (file) => {

    return new Promise((resolve, reject) => {

        const reader = new FileReader();

        // Resolve with the base64 result when the file is loaded
        reader.onload = (e) => resolve(e.target.result);

        // Reject the promise if there is an error reading the file
        reader.onerror = (error) => reject(error);

        // Read the file as a data URL (Base64 string)
        reader.readAsDataURL(file);

    });

};

//==================================================================//
//========================= Altera Anexos ==========================//
//==================================================================//

const alteraAnexos = async (arquivos) =>{

    let anexos = await UtilSequence.each({
        list: arquivos,
        callback: async (arquivo)=>{

            let arquivoBase64 = await converteParaBase64(arquivo);

            return{
                nome: arquivo.name,
                arquivo: arquivo,
                base64: arquivoBase64
            }

        },
    });

    emits('update:email',{
        anexos: anexos
    });

}

//==================================================================//
//============================= Watch ==============================//
//==================================================================//

watch(()=> props.pedidoDeCompra, () => {

    anexos.value = undefined

});

</script>

<template>

  <v-card
        class="c-anexo-email"
    >

        <v-card-title
            class="c-anexo-email__titulo"
        >
        
            <h3>Anexos</h3>

        </v-card-title>

        <div
            class="c-anexo-email__conteudo"
        >
        
            <v-file-input
                v-model="anexos"
                label="Arquivos Anexos"
                placeholder="Clique para Anexar os seus arquivos."
                counter
                multiple
                show-size
                outlined
                @change="alteraAnexos"
            >
        
                <template v-slot:selection="{ text }">

                    <v-chip
                        small
                        label
                        color="primary"
                    >

                        {{ text }}

                    </v-chip>

                </template>

            </v-file-input>

        </div>

    </v-card>

</template>

<style scoped>


</style>